export default __webpack_public_path__ + "static/media/rain-3.23fbf0a3.png";